export enum AgentType {
    orderProcessing = "orderProcessing",
    marketingCampaign = "marketingCampaign",
    EDIAssistant = "EDIAssistant",
    InventoryManagement = "InventoryManagement",
    NewProductForecaster = "NewProductForecaster",
    TargetAlly = "TargetAlly",
}
